import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Link from 'next/link'
import cName from "classnames";
import styles from './index.module.scss';
import Wrapper from '@/components/wrapper';
import CountUp from 'react-countup';
import { getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export { getServerSideProps }

export default ({ menuDetail }: any) => {
  const t = useTranslations("innovative");
  const router = useRouter();

  return (
    <div>
      <Wrapper banner="" showCrumb={false} showPendant={false}>
        <div className={styles.container}>
          {getHead(menuDetail)}
          <div className={cName(styles.bannerBox, 'm-1600')}>
            <img src="/image/technology/content.png?t=202610301800" alt="" />
          </div>
          <section className={cName(styles.section1, 'm-1600')}>
            <div className={styles.round}>
              <div className={styles.item}>
                <div>
                  {t("section1.item1Currency")}
                  <CountUp
                    end={Number(t("section1.item1num"))}
                    duration={1}
                    enableScrollSpy
                    decimals={1}
                  />
                  {t("section1.item1unit")}
                </div>
                <div>{t("section1.item1tit")}</div>
              </div>
              <div className={styles.item}>
                <div>
                  {t("section1.item2Currency")}
                  {
                    router.locale === 'en'
                      ?
                      <CountUp
                        end={Number(t("section1.item2num"))}
                        duration={1}
                        enableScrollSpy
                        decimals={1}
                      />
                      :
                      <CountUp
                        end={Number(t("section1.item2num"))}
                        duration={1}
                        enableScrollSpy
                        decimals={0}
                      />
                  }
                  {t("section1.item2unit")}
                </div>
                <div>{t("section1.item2tit")}</div>
              </div>
              <div className={styles.item}>
                <div>
                  {t("section1.item3Currency")}
                  <CountUp
                    end={Number(t("section1.item3num"))}
                    duration={1}
                    enableScrollSpy
                    decimals={1}
                  />
                  {t("section1.item3unit")}
                </div>
                <div>{t("section1.item3tit")}</div>
              </div>
            </div>
            <div className={styles.rich}>
              <div className={styles.item}>
                <div className={styles.title1}>{t("section1.title1")}</div>
                <div className={styles.subTitle}>{t("section1.subtitle1")}</div>
                <div className={styles.text}>
                  {
                    t.rich('section1.text1', {
                      p: (chunks) => <p>{chunks}</p>,
                      br: () => <br />,
                    })
                  }
                </div>
              </div>
              <div className={styles.item}>
                <div className={cName(styles.title2, router.locale === 'en' ? styles.en : '')}>{t("section1.title2")}</div>
                <div className={styles.subTitle}>{t("section1.subtitle2")}</div>
                <ul className={styles.list}>
                  <li>
                    <p>{t("section1.text2.item1Title")}</p>
                    <span>{t("section1.text2.item1Text")}</span>
                  </li>
                  <li>
                    <p>{t("section1.text2.item2Title")}</p>
                    <span>{t("section1.text2.item2Text")}</span>
                  </li>
                  <li>
                    <p>{t("section1.text2.item3Title")}</p>
                    <span>{t("section1.text2.item3Text")}</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <ul className={cName(styles.photoBox, 'm-1600')}>
            <li><img src="/image/technology/image1.png" alt="" /></li>
            <li><img src="/image/technology/image2.png" alt="" /></li>
            <li><img src="/image/technology/image3.png" alt="" /></li>
            <li><img src="/image/technology/image4.png" alt="" /></li>
            <li><img src="/image/technology/image5.png" alt="" /></li>
          </ul>
          <section className={cName(styles.section2, 'm-1600')}>
            <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>{t("section2.title")}</div>
            <div className={styles.text}>{t("section2.text")}</div>
            <div className={styles.box}>
              <div className={styles.left}>
                <div className={styles.label}>{t("section2.item1.title")}</div>
                <div className={styles.type}>{t("section2.item1.cate1")}</div>
                <p>{t("section2.item1.text1")}</p>
                <p className={styles.type}>{t("section2.item1.cate2")}</p>
                <p>{t("section2.item1.text2")}</p>
                <p className={styles.type}>{t("section2.item1.cate3")}</p>
                <p>{t("section2.item1.text3")}</p>
              </div>
              <div className={styles.right}>
                <div className={styles.top}>
                  <div className={styles.label}>{t("section2.item2.title")}</div>
                  <p>{t("section2.item2.text1")}</p>
                </div>
                <div className={styles.bottom}>
                  <div className={styles.label}>{t("section2.item3.title")}</div>
                  <p>{t("section2.item3.text1")}</p>
                </div>
              </div>
            </div>
          </section>
          <section className={cName(styles.section3, 'm-1600')}>
            <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>{t("section3.item1tit")}</div>
              <img className={styles.cover} src="/image/technology/item6.png?t=202610291711" alt="" />
              <div className={styles.text}>{t("section3.item1txt")}</div>
            </div>
            <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>{t("section3.item2tit")}</div>
              <img className={styles.cover} src="/image/technology/item7.png?t=202610291711" alt="" />
              <div className={styles.text}>{t("section3.item2txt")}</div>
            </div>
            {/* <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>{t("section3.item3tit")}</div>
              <img className={styles.cover} src="/image/technology/item8.png" alt="" />
              <div className={styles.text}>{t("section3.item3txt")}</div>
            </div> */}
          </section>
          <section className={cName(styles.section4, 'm-1600')}>
            <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>
                {
                  t.rich('section4.item1.title', {
                    br: () => <br />,
                  })
                }
              </div>
              <div className={styles.company}>{t("section4.item1.company")}</div>
              <div className={styles.arr}>
                <div className={styles.itm}>
                  <p>{t("section4.item1.contact1name")}</p>
                  <div className={`${styles.contact} ${styles.tel}`}>{t("section4.item1.contact1tel")}</div>
                  <div className={`${styles.contact} ${styles.phone}`}>{t("section4.item1.contact1phone")}</div>
                  <div className={`${styles.contact} ${styles.email}`}>{t("section4.item1.contact1email")}</div>
                </div>
                <div className={styles.itm}>
                  <p>{t("section4.item1.contact2name")}</p>
                  <div className={`${styles.contact} ${styles.tel}`}>{t("section4.item1.contact2tel")}</div>
                  <div className={`${styles.contact} ${styles.phone}`}>{t("section4.item1.contact2phone")}</div>
                  <div className={`${styles.contact} ${styles.email}`}>{t("section4.item1.contact2email")}</div>
                </div>
              </div>
            </div>
            {/* <div className={styles.line}></div> */}
            <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>
                {
                  t.rich('section4.item2.title', {
                    br: () => <br />,
                  })
                }
              </div>
              <div className={styles.company}>{t("section4.item2.company")}</div>
              <div className={styles.arr}>
                <div className={styles.itm}>
                  <p>{t("section4.item2.contact1name")}</p>
                  <div className={`${styles.contact} ${styles.tel}`}>{t("section4.item2.contact1tel")}</div>
                  {/* <div className={`${styles.contact} ${styles.phone}`}>手机：+86(0) 13375193683</div> */}
                  <div className={`${styles.contact} ${styles.email}`}>{t("section4.item2.contact1email")}</div>
                </div>
              </div>
            </div>
            {/* <div className={styles.line}></div> */}
            <div className={styles.item}>
              <div className={cName(styles.title, router.locale === 'en' ? styles.en : '')}>
                {
                  t.rich('section4.item3.title', {
                    br: () => <br />,
                  })
                }
              </div>
              <div className={styles.company}>{t("section4.item3.company")}</div>
              <div className={styles.arr}>
                <div className={styles.itm}>
                  <p>{t("section4.item3.contact1name")}</p>
                  <div className={`${styles.contact} ${styles.tel}`}>{t("section4.item3.contact1tel")}</div>
                  <div className={`${styles.contact} ${styles.email}`}>{t("section4.item3.contact1email")}</div>
                </div>
              </div>
            </div>
            <div className={styles.location}>
              <img src="/image/technology/location.png?t=202606161804" alt="" />
            </div>
          </section>
        </div>
      </Wrapper>
    </div>
  );
};